import React from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import TechAreas from './components/TechAreas';
import Approach from './components/Approach';
import ExtraInfo from './components/ExtraInfo';
import Footer from './components/Footer';
import ClickSpark from './components/ClickSpark/ClickSpark';

function App() {
  return (
    <ClickSpark
      sparkColor='#fff'
      sparkSize={10}
      sparkRadius={15}
      sparkCount={8}
      duration={400}
    >
      <div className="App">
        <Hero />
        <Services />
        <TechAreas />
        <Approach />
        <ExtraInfo />
        <Footer />
      </div>
    </ClickSpark>
  );
}

export default App;